import { render, staticRenderFns } from "./CostBearerPaymentDocuments.vue?vue&type=template&id=3653882f"
import script from "./CostBearerPaymentDocuments.vue?vue&type=script&lang=ts"
export * from "./CostBearerPaymentDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports